// extracted by mini-css-extract-plugin
module.exports = {"fields-container":"AaxBN","footer":"_8v2Gq","reset-btn":"RS2-o","discount-form":"Or7cz","discount":"csSgq","input":"juNpW","apply":"JrlUM","error":"_5op67"};